/* HM Metalworks motion layer — scroll-reveal for rich-text pages. Additive, safe to remove. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.main-content .rte > h1',
    '.main-content .rte > h2',
    '.main-content .rte > h3',
    '.main-content .rte > p',
    '.main-content .rte > ul',
    '.main-content .rte > ol',
    '.main-content .rte img',
    '.main-content .page__content > h1',
    '.main-content .page__content > h2',
    '.main-content .page__content > h3',
    '.main-content .page__content > p',
    '.main-content .page__content img'
  ].join(',');

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SELECTORS)).filter(function (el) {
      // Skip anything the theme's own AOS animations already handle
      return !el.closest('[data-aos]') && !el.classList.contains('hm-reveal');
    });
    if (!els.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hm-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    els.forEach(function (el, i) {
      el.classList.add('hm-reveal');
      el.style.setProperty('--hm-delay', (i % 5) * 0.07 + 's');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
